export const T_SEARCH_PARAM = 't_search';
